module.exports = __webpack_public_path__ + "img/analyse-img.be35eb2d.png";